import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import SeekerProfile from "@/pages/SeekerProfile";
import EmployerProfile from "@/pages/EmployerProfile";
import PostJob from "@/pages/PostJob";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import EmployerJobDetail from "@/pages/EmployerJobDetail";
import EmployerCandidates from "@/pages/EmployerCandidates";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import AdminPanel from "@/pages/AdminPanel";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ProtectedRoute from "@/components/ProtectedRoute";
import PracticeLanding from "@/pages/practice/PracticeLanding";
import ApiPlayground from "@/pages/practice/ApiPlayground";
import LevelBasic from "@/pages/practice/levels/LevelBasic";
import LevelForms from "@/pages/practice/levels/LevelForms";
import LevelMouseKeyboard from "@/pages/practice/levels/LevelMouseKeyboard";
import LevelComplex from "@/pages/practice/levels/LevelComplex";
import LevelDynamic from "@/pages/practice/levels/LevelDynamic";
import LevelBrowser from "@/pages/practice/levels/LevelBrowser";
import LevelAdvanced from "@/pages/practice/levels/LevelAdvanced";
import DemoBanner from "@/components/DemoBanner";

function InnerRouter() {
  const location = useLocation();
  // Synchronously handle Emergent OAuth callback to prevent race conditions
  if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/jobs" element={<Jobs />} />
      <Route path="/jobs/:id" element={<JobDetail />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />

      <Route path="/practice" element={<PracticeLanding />} />
      <Route path="/practice/api" element={<ApiPlayground />} />
      <Route path="/practice/level/basic" element={<LevelBasic />} />
      <Route path="/practice/level/forms" element={<LevelForms />} />
      <Route path="/practice/level/mouse-keyboard" element={<LevelMouseKeyboard />} />
      <Route path="/practice/level/complex" element={<LevelComplex />} />
      <Route path="/practice/level/dynamic" element={<LevelDynamic />} />
      <Route path="/practice/level/browser" element={<LevelBrowser />} />
      <Route path="/practice/level/advanced" element={<LevelAdvanced />} />

      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute role="job_seeker"><SeekerProfile /></ProtectedRoute>} />
      <Route path="/employer/profile" element={<ProtectedRoute role="employer"><EmployerProfile /></ProtectedRoute>} />
      <Route path="/employer/post-job" element={<ProtectedRoute role="employer"><PostJob /></ProtectedRoute>} />
      <Route path="/employer/candidates" element={<ProtectedRoute role="employer"><EmployerCandidates /></ProtectedRoute>} />
      <Route path="/employer/job/:id" element={<ProtectedRoute role="employer"><EmployerJobDetail /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute role="admin"><AdminPanel /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <DemoBanner />
          <InnerRouter />
          <Toaster richColors closeButton position="bottom-right" offset={16} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
